import { render } from "./NoticeForm.vue?vue&type=template&id=1a3e68ce&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"

import "./NoticeForm.vue?vue&type=style&index=0&id=1a3e68ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3e68ce"]])

export default __exports__